<template>
  <div
    class="flex min-h-full flex-1 flex-col justify-end overflow-y-auto"
  >
    <div class="flex flex-1 flex-col justify-center px-6">
      <div
        class="flex flex-1 flex-col justify-center space-y-1"
      >
        <CustomAmountDisplay
          :value="amountInput"
          class="mt-5 w-full"
        />
        <NoteInput v-model="note" />
      </div>
      <div class="pb-6">
        <ActionButtonPrimary
          class="m-auto flex items-center justify-between py-1"
          :disabled="addItemButtonDisabled"
          @click="handlePlusClick"
        >
          <IconPlus class="mr-1" />
          Add Item
        </ActionButtonPrimary>
      </div>
    </div>
    <BaseNumpad v-model="amountInput" />
  </div>
</template>

<script setup>
const amountInput = ref(0)
const note = ref("")

const { addItem } = useCurrentOrder()

const addItemButtonDisabled = computed(
  () => amountInput.value === 0
)

const handlePlusClick = () => {
  addItem({
    price: amountInput.value,
    note: note.value,
    product: null,
    modifiers: null,
    quantity: 1,
  })
  amountInput.value = 0
  note.value = ""
}
</script>
